"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClusterOverview = void 0;
require("./ClusterOverview.scss");
const React = require("react");
const Cluster_1 = require("../../util/Cluster");
const Generic_1 = require("../../legends/Generic");
const core_1 = require("@material-ui/core");
const ToggleButton_1 = require("@material-ui/lab/ToggleButton");
const react_redux_1 = require("react-redux");
const GenericChanges_1 = require("../../legends/GenericChanges/GenericChanges");
const CurrentClustersDuck_1 = require("../../Ducks/CurrentClustersDuck");
const StoriesDuck_1 = require("../../Ducks/StoriesDuck");
const mapStateToProps = (state) => ({
    storyMode: state.storyMode,
    dataset: state.dataset,
    stories: state.stories,
    currentAggregation: state.currentAggregation
});
const mapDispatch = dispatch => ({
    addCluster: cluster => dispatch(CurrentClustersDuck_1.addCluster(cluster)),
    addClusterToTrace: cluster => dispatch(StoriesDuck_1.addClusterToTrace(cluster)),
    setActiveTraceState: cluster => dispatch(StoriesDuck_1.setActiveTraceState(cluster)),
    selectSideBranch: index => dispatch(StoriesDuck_1.selectSideBranch(index))
});
const connector = react_redux_1.connect(mapStateToProps, mapDispatch);
const Plus = ({ onClick, x, y, r }) => {
    return React.createElement("g", { onClick: () => {
            onClick();
        } },
        React.createElement("circle", { cx: x, cy: y, r: r, fill: "#F0F0F0", "stroke-width": "2", stroke: "red" }),
        React.createElement("line", { x1: x - r + 3, y1: y, x2: x + r - 3, y2: y, "stroke-width": "2", stroke: "red" }),
        React.createElement("line", { x1: x, y1: y - r + 3, x2: x, y2: y + r - 3, "stroke-width": "2", stroke: "red" }));
};
const Circle = ({ x, y, onClick }) => {
    return React.createElement("circle", { cx: x, cy: y, r: "6", fill: "blue", onClick: onClick });
};
exports.ClusterOverview = connector(function ({ dataset, itemClicked, storyMode, stories, currentAggregation, addCluster, addClusterToTrace, setActiveTraceState, selectSideBranch }) {
    var _a, _b;
    if (stories.trace == null || stories.active == null) {
        return null;
    }
    const itemRef = React.useRef();
    const [active, setActive] = React.useState(0);
    const [position, setPositions] = React.useState([]);
    React.useEffect(() => {
        const current = itemRef.current;
        if (current) {
            const state = [];
            for (var i = 1; i < current.children.length; i++) {
                const child = current.children[i];
                state.push({ y: child.offsetTop + child.offsetHeight / 2 - current.children[1].offsetTop });
            }
            setPositions(state);
        }
    }, [stories]);
    React.useEffect(() => {
        setActiveTraceState(stories.trace.mainPath[0]);
    }, [stories.trace]);
    return React.createElement(core_1.Grow, { in: stories.active != null },
        React.createElement(core_1.Card, { className: "ClusterOverviewParent" },
            React.createElement("div", { style: { display: 'flex', flexDirection: 'column', height: '100%', overflowY: 'auto' } },
                React.createElement("div", { style: { display: 'flex', flexDirection: 'row' } },
                    React.createElement("div", null,
                        React.createElement(core_1.Typography, { align: "center", variant: "subtitle2" }, "Provenance"),
                        React.createElement("svg", { style: {
                                width: '100%',
                                height: '100%',
                                maxWidth: '120px',
                                minHeight: '200px',
                                minWidth: '100px'
                            } },
                            position.map((p, index) => {
                                let cluster = stories.trace.mainPath[index];
                                let sidePathIndex = stories.trace.sidePaths.findIndex(sidePath => {
                                    return sidePath.edges.find(edge => edge.source == cluster);
                                });
                                return React.createElement("g", null,
                                    React.createElement("text", { x: "60", y: p.y, fill: "black" }, index),
                                    React.createElement("circle", { cx: "50", cy: p.y, r: "6", fill: "blue" }),
                                    sidePathIndex >= 0 &&
                                        React.createElement("g", null,
                                            React.createElement("line", { x1: 50, y1: p.y, x2: 30, y2: p.y + 40, stroke: "gray", strokeWidth: 2 }),
                                            React.createElement(Circle, { x: 30, y: p.y + 40, onClick: () => {
                                                    selectSideBranch(sidePathIndex);
                                                } })));
                            }),
                            position.map((p, i) => {
                                if (i != position.length - 1) {
                                    let p1 = p;
                                    let p2 = position[i + 1];
                                    return React.createElement("line", { x1: 50, y1: p1.y, x2: 50, y2: p2.y, stroke: "blue", strokeWidth: "2" });
                                }
                                else {
                                    let p1 = p;
                                    let p2 = { x: p1.x, y: p1.y + 40 };
                                    return React.createElement("g", null,
                                        React.createElement("line", { x1: 50, y1: p1.y, x2: 50, y2: p2.y, stroke: "blue", strokeWidth: "2" }),
                                        React.createElement(Plus, { x: 50, y: p2.y, r: 10, onClick: () => {
                                                let cluster = Cluster_1.default.fromSamples(currentAggregation);
                                                addCluster(cluster);
                                                addClusterToTrace(cluster);
                                            } }));
                                }
                            }),
                            position.length == 0 && React.createElement("g", null,
                                React.createElement("line", { x1: 50, y1: 0, x2: 50, y2: 100, stroke: "blue", strokeWidth: "2" }),
                                React.createElement(Plus, { x: 50, y: 50, r: 10, onClick: () => {
                                        if (currentAggregation.length > 0) {
                                            let cluster = Cluster_1.default.fromSamples(currentAggregation);
                                            addCluster(cluster);
                                            addClusterToTrace(cluster);
                                        }
                                    } })))),
                    React.createElement("div", { ref: itemRef, style: {
                            display: 'flex',
                            flexDirection: 'column',
                            minWidth: '100px'
                        } },
                        React.createElement(core_1.Typography, { align: "center", variant: "subtitle2" }, "Cluster"), (_a = stories.trace) === null || _a === void 0 ? void 0 :
                        _a.mainPath.map((cluster, index) => {
                            return React.createElement(ToggleButton_1.default, { key: index, className: "ClusterItem", selected: stories.activeTraceState == cluster, value: index, onClick: () => {
                                    itemClicked(cluster);
                                    setActiveTraceState(cluster);
                                } },
                                React.createElement(Generic_1.GenericFingerprint, { type: dataset.type, vectors: cluster.vectors, scale: 1 }));
                        })),
                    React.createElement("div", { style: {
                            display: 'flex',
                            flexDirection: 'column',
                            minWidth: '100px'
                        } },
                        React.createElement(core_1.Typography, { align: "center", variant: "subtitle2" }, "Change"), (_b = stories.trace) === null || _b === void 0 ? void 0 :
                        _b.mainEdges.map((edge, index) => {
                            return React.createElement(ToggleButton_1.default, { key: index, className: "ClusterItem CORightItem", value: index, onClick: () => {
                                    itemClicked(edge.destination);
                                } },
                                React.createElement(GenericChanges_1.GenericChanges, { scale: 1, vectorsA: edge.source.vectors, vectorsB: edge.destination.vectors }));
                        }))))));
});
